import React, { useEffect, useState } from 'react';
import { Button, DatePicker, Form, Input, Modal, Select, message } from 'antd';
import { Colors } from '../../helpers/Colors';
import { gellAllLocomotiveLocations, getAllLocomotive, getAllStatus, getTicketCategory, updateEquipmentById, updateEquipmentLocation, updateEquipmentStatus, updateFraStatus, updateLocomotiveTicketModal, updateTicketCategory, updateWorkOrderById } from '../../Services/LocomotiveServices';
// import DatePicker from 'react-date-picker';
import { AssignTo, ContractorTo, get_employee_AssignTo_listing_not_Terminated, get_employee_listing_not_Terminated } from '../../Services/employee';
import moment from 'moment';
import dayjs from 'dayjs';
import { ArrowUpwardOutlined } from '@material-ui/icons';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Option } from 'antd/lib/mentions';

const LocomotiveWorkOrderModal = ({ TicketIdCategory, open, close, data }) => {

    const [form] = Form.useForm()
    const [EmployeeListData, setEmployeeListData] = useState([])
    const [ContractorListData, setContractorListData] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedValue, setSelectedValue] = useState(null);
    const [showBackButton, setShowBackButton] = useState(false);

    const getUpdateCategory = async (values) => {
        const result = await updateTicketCategory(TicketIdCategory, values)
    };

    const getTicketCategories = async () => {

        const TicketID = 4;
        const result = await getTicketCategory(TicketID)
        if (result?.httpStatus === 200) {
            const data = result?.data.map((item, index) => {
                return {
                    label: item?.name,
                    value: item?.id
                }
            })
            setCategories(data)
        }
    }


    const handleOptionChange = (value) => {
        setSelectedOption(value);
        setSelectedValue();
        form.setFieldsValue({
            wo_Assigned_To: selectedValue,
            ticket_Category: selectedValue
        });
        setShowBackButton(true);
    };

    const contractormap = (data) => {
        if (data) {
            let {
                firstName,
                lastName,
                Company
            } = data;

            let output = '';

            if (Company)
                output = Company;

            if (Company && firstName && lastName)
                output = output + "-"

            if (firstName && lastName)
                output = `${output} ${firstName} ${lastName[0]}.`

            return output;
        }

        return ''

    };
    const getEmployeeData = async () => {
        let result = await get_employee_AssignTo_listing_not_Terminated()
        if (result?.httpStatus === 200) {
            const list = result?.data?.rows?.map((item, index) => {
                return {
                    label: `${item?.firstName} ${item?.lastName}`,
                    value: item?.id
                }
            })
            setEmployeeListData(list)
            form.setFieldsValue({
                wo_Assigned_To: data?.values?.AssignedToId
            })
        }
    }

    const getContractorData = async () => {
        let result = await ContractorTo();
        if (result?.httpStatus === 200) {
            const list = result?.data?.map((item, index) => {
                return {
                    label: `${contractormap(item)}`,
                    value: item?.id
                };

            });
            setContractorListData(list);
            form.setFieldsValue({
                wo_Assigned_To: data?.values?.AssignedToContractorId
            })
        }
    };

    const onChange = (value) => {
        if (value === 'Back') {
            // Handle going back based on your specific requirements
            // For example, decrement the current step
            setSelectedOption(null);
            form?.setFieldsValue({
                selectOption: null
            })
        }
    };
    const onSearch = (value) => {
    };
    const filterOption = (input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())

    const handleSubmit = async (values, type) => {
        let payload = {}
        if (type === 'wo_Assigned_To') {
            payload.AssignedToId = values?.wo_Assigned_To
        }
        else if (type === 'wo_Schedule_Date') {
            payload.ScheduleDate = values?.wo_Schedule_Date.format('MM-DD-YYYY')
        }
        else if (type === 'wo_Discription') {
            payload.Description = values?.wo_Discription
        }
        // if (type == 'ticket_Category') {
        //     payload = { ...values }
        // }
        if (type === 'ticket_Category') {
            // const payload = { ...values }
            await getUpdateCategory(values);
            message.success('Category Updated Successfully!');
            close();
            return
        } else {
            const result = await updateWorkOrderById(data?.values?.id, payload)
            if (result?.httpStatus === 200) {
                message.success('Updated Successfully!');
                close()
            }
        }
    }
    useEffect(() => {
        if (selectedOption === 'employee') {
            form.setFieldsValue({
                wo_Assigned_To: selectedValue,
            });
        } else if (selectedOption === 'contractor') {
            form.setFieldsValue({
                wo_Assigned_To: selectedValue,
            });
        }
    }, [selectedOption, selectedValue]);
    useEffect(() => {
        getEmployeeData();
        getContractorData();
        if (data?.label?.key == "ticket_Category") {
            getTicketCategories()
        }
        if (data?.values?.AssignedToId) {
            // setSelectedValue(data?.values?.AssignedToId);
            getEmployeeData();
            setSelectedOption('employee');
        } else if (data?.values?.AssignedToContractorId) {
            getContractorData();
            setSelectedOption('contractor');
            // setSelectedValue(data?.values?.AssignedToContractorId);
        }
    }, [open])
    useEffect(() => {
        form.setFieldsValue({
            wo_Assigned_To: null,
            selectOption: null
        });
        setSelectedOption(null)
    }, [data])

    return (
        <>
            <Modal title={<p style={{ color: Colors.mainBlue, fontWeight: "600", marginBottom: "0px ", fontSize: "20px" }}>Update {data?.label?.name}</p>} open={open} onCancel={() => {
                close()
                form.setFieldsValue({
                    wo_Assigned_To: null,
                    selectOption: null
                });
                setSelectedOption(null)
            }} footer={null} >
                <Form
                    name='Locomotive Ticket Form'
                    onFinish={(values) => { handleSubmit(values, data?.label?.key) }}
                    form={form}
                    initialValues={{
                        wo_Schedule_Date: moment(data?.values?.ScheduleDate || new Date() || 'MM-DD-YYYY'),
                        // Add other initial values if needed
                    }}
                >
                    <>
                        <div style={{ display: "flex", alignItems: 'center', marginBottom: "10px" }}>
                            <p style={{ width: "150px", fontSize: "16px", fontWeight: "700", whiteSpace: "nowrap", marginRight: "20px", marginTop: '10px' }}>{data?.label?.name}</p>
                            {data?.label?.key === "ticket_Category" ?
                                (<Form.Item
                                    name="TicketCategoryId"
                                    rules={[{ required: true, message: 'Please select an option' }]}
                                >
                                    <Select
                                        style={{ width: "290px", marginRight: "20px", marginTop: '10px' }}
                                        value={selectedOption}
                                        showSearch
                                        filterOption={(inputValue, option) => option.children ? option.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1 : null}
                                        onChange={handleOptionChange}
                                        placeholder='Select Option'
                                    >
                                        {
                                            categories?.map(({ value, label }) => (
                                                <Select.Option value={value}>{label}</Select.Option>
                                            ))
                                        }
                                    </Select>
                                </Form.Item>)
                                :
                                (selectedOption == 'Back' && data?.label?.key == "wo_Assigned_To" || selectedOption == null && data?.label?.key == "wo_Assigned_To") ?
                                    (
                                        <Form.Item
                                            name="selectOption"
                                            rules={[{ required: true, message: 'Please select an option' }]}
                                        >
                                            <Select
                                                style={{ width: "200px", marginRight: "20px", marginTop: '10px' }}
                                                value={selectedOption || undefined}
                                                onChange={handleOptionChange}
                                                placeholder='Select Option'
                                            >
                                                <Select.Option value="employee">Employee</Select.Option>
                                                <Select.Option value="contractor">Contractor</Select.Option>
                                            </Select>
                                        </Form.Item>


                                    )
                                    : (
                                        <Form.Item name={data?.label?.key} rules={[{ required: true, message: "Kindly enter value" }]} style={{ margin: "0px", width: '80%' }}>
                                            {data?.label?.key === 'wo_Schedule_Date' ? (
                                                // <DatePicker
                                                //     // defaultValue = {moment(data?.values?.ScheduleDate || new Date(), dateFormat || 'MM-DD-YYYY')}
                                                //     // format={dateFormat}
                                                // />
                                                <DatePicker
                                                    format="MM-DD-YYYY" // Specify the desired date format
                                                />
                                            ) : data?.label?.key === 'wo_Discription' ? (
                                                <Input.TextArea
                                                    rows={4}
                                                    placeholder="Enter Description"
                                                    defaultValue={data?.values?.Description}
                                                    maxLength='1000'
                                                    style={{ width: '100%' }}
                                                />
                                            ) : (
                                                selectedOption === 'employee' ? (
                                                    <Select

                                                        style={{ width: "250px" }}
                                                        showSearch
                                                        value={data?.values?.Assignedto?.firstName}
                                                        optionFilterProp="children"
                                                        onChange={onChange}
                                                        onSearch={onSearch}
                                                        filterOption={(inputValue, option) => option.children ? option.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1 : null}
                                                        // options={EmployeeListData}
                                                        required={true}
                                                    >
                                                        <Select.Option style={{ textAlign: 'center', fontWeight: 'bold' }} value="Back">Back</Select.Option>

                                                        {
                                                            EmployeeListData?.map((item) => (
                                                                <Select.Option value={item?.value}>{item?.label}</Select.Option>
                                                            ))
                                                        }
                                                    </Select>
                                                ) : selectedOption === 'contractor' ? (
                                                    <Select
                                                        style={{ width: "250px" }}
                                                        showSearch
                                                        value={data?.values?.AssignedtoContractor?.firstName}
                                                        optionFilterProp="children"
                                                        onChange={onChange}
                                                        onSearch={onSearch}
                                                        filterOption={(inputValue, option) => option.children ? option.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1 : null}
                                                        // options={ContractorListData}
                                                        required={true}
                                                    >
                                                        <Select.Option style={{ textAlign: 'center', fontWeight: 'bold' }} value={'Back'}>Back</Select.Option>
                                                        {
                                                            ContractorListData?.map((item) => (
                                                                <Select.Option value={item?.value}>{item?.label}</Select.Option>
                                                            ))
                                                        }

                                                    </Select>

                                                ) : null

                                            )}
                                        </Form.Item>
                                    )}
                        </div>
                        <div style={{ display: "flex", justifyContent: "end" }} >
                            <Button htmlType='submit' style={{ background: Colors.mainBlue, color: "white", border: "none", marginTop: "30px" }}>Update</Button>
                        </div>
                    </>
                </Form>
            </Modal>
        </>
    );
};
export default LocomotiveWorkOrderModal;